import {call, delay, put, takeLatest} from 'redux-saga/effects'
import {ParamsModel} from 'src/app/modules/common/Model'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {SortNabilAuctionModel, SortSearchActionModel} from '../Model/Model'
import {actions} from './action'
import {actionTypes} from './constants'
import {service} from './service'

function* getNabilAuctionSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload

    yield delay(500)
    const response: ResponseModel = yield call(service.getNabilAuction, params)
    yield put(actions.getNabilAuctionSuccess(response?.data?.data))
    yield put(actions.getNabilAuctionFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.getNabilAuctionFinish())
  }
}

function* addNabilAuctionSaga(action: ActionModel) {
  try {
    const body = action.payload
    const response: ResponseModel = yield call(service.addNabilAuction, body)
    yield put(actions.addNabilAuctionSuccess(response.data?.data))
    yield put(actions.addNabilAuctionFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.addNabilAuctionFinish())
  }
}

function* enableNabilAuctionSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.enableNabilAuction, selectedUsers)
    yield put(actions.enableNabilAuctionSuccess(response?.data))
    yield delay(100)
    yield put(actions.enableNabilAuctionFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.enableNabilAuctionFinish())
  }
}

function* disableNabilAuctionSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.disableNabilAuction, selectedUsers)
    yield put(actions.disableNabilAuctionSuccess(response?.data))
    yield delay(100)
    yield put(actions.disableNabilAuctionFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.enableNabilAuctionFinish())
  }
}

function* singleEnableNabilAuctionSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleEnableNabilAuction, selectedUsers)
    yield put(actions.singleEnableNabilAuctionSuccess(response?.data))
    yield delay(100)
    yield put(actions.singleEnableNabilAuctionFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.singleEnableNabilAuctionFinish())
  }
}

function* singleDisableNabilAuctionSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleDisableNabilAuction, selectedUsers)
    yield put(actions.singleDisableNabilAuctionSuccess(response?.data))
    yield delay(100)
    yield put(actions.singleDisableNabilAuctionFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.singleDisableNabilAuctionFinish())
  }
}

function* updateNabilAuctionSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.updateNabilAuction, body, (action as any).id)
    yield put(actions.updateNabilAuctionSuccess(response.data?.data))
    yield put(actions.updateNabilAuctionFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.updateNabilAuctionFinish())
  }
}

function* deleteNabilAuctionSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteNabilAuction, body)
    yield put(actions.deleteNabilAuctionSuccess(response.data?.data))
    yield delay(0.1)
    yield put(actions.deleteNabilAuctionFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.deleteNabilAuctionFinish())
  }
}

function* sortNabilAuction(action: SortSearchActionModel) {
  try {
    const body: SortNabilAuctionModel = action.payload
    const response: ResponseModel = yield call(service.getNabilAuction, body as any)

    yield put({
      type: actionTypes.SORT_NABIL_AUCTION_SUCCESS,
      payload: response?.data?.data?.nabilAuction,
    })
    yield delay(100)
    yield put({type: actionTypes.SORT_NABIL_AUCTION_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put({type: actionTypes.SORT_NABIL_AUCTION_FINISH})
  }
}

function* getNabilAuctionCategoryListSaga() {
  try {
    const response: ResponseModel = yield call(service.getNabilAuctionCategoryList)
    yield put(actions.getNabilAuctionCategoryListSuccess(response.data?.data))
    yield put(actions.getNabilAuctionCategoryListFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getNabilAuctionCategoryListFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_NABIL_AUCTION_START, getNabilAuctionSaga)
  yield takeLatest(actionTypes.ADD_NABIL_AUCTION_START, addNabilAuctionSaga)
  yield takeLatest(actionTypes.UPDATE_NABIL_AUCTION_START, updateNabilAuctionSaga)
  yield takeLatest(actionTypes.DELETE_NABIL_AUCTION_START, deleteNabilAuctionSaga)
  yield takeLatest(actionTypes.ENABLE_NABIL_AUCTION_REQUEST, enableNabilAuctionSaga)
  yield takeLatest(actionTypes.DISABLE_NABIL_AUCTION_REQUEST, disableNabilAuctionSaga)
  yield takeLatest(actionTypes.SINGLE_ENABLE_NABIL_AUCTION_REQUEST, singleEnableNabilAuctionSaga)
  yield takeLatest(actionTypes.SINGLE_DISABLE_NABIL_AUCTION_REQUEST, singleDisableNabilAuctionSaga)
  yield takeLatest(actionTypes.SORT_NABIL_AUCTION_START, sortNabilAuction)
  yield takeLatest(actionTypes.GET_NABIL_AUCTION_CATEGORY_LIST_START, getNabilAuctionCategoryListSaga)
}
